import * as admins from 'src/api/admins'
import {
  GET_ALL_ADMINS
} from 'src/store/mutation-types'

const getAllAdmins = ({commit, dispatch}, params = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  admins.getAllAdmins(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ADMINS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ADMINS, [])
    }
  })
}

export default {
  getAllAdmins
}



// WEBPACK FOOTER //
// ./src/components/admin/store/actions.js